import React from 'react';
import { TipToastFrame } from './TipToastFrame';
import { VCredit } from '../keno/VCredit';
import { KickLogo } from '../SocialIcons';

export const KickRewardToast = ({ notice, onDismiss }) => <TipToastFrame id={notice.id} direction="received" testPrefix="kick-reward" dismiss={onDismiss}>
  <span className="tip-toast-heading"><KickLogo className="kicklet-brand" />{notice.title}</span>
  <span className="tip-toast-message"><VCredit minor={notice.amount_minor} testid={`kick-reward-toast-amount-${notice.id}`} /><span>credited to your V-Credits balance.</span></span>
</TipToastFrame>;